import { useDispatch } from 'react-redux';
import logo2 from '../../static/img/logo-2.svg';
import pay_logos from '../../static/img/PAY_LOGOS.png';
import { setShowPopUpManager } from '../home/homeSlice';

export function Footer() {
    const dispatch = useDispatch()
    return (
        <footer className="footer">
            <div className="conteiner">
                <div className="footer-contant">
                    <div className="footer-contant-up">
                        <div className="footer-contant-up-col footer-contant-up-col-1">
                            <h2 className="h2 h2-footer">Остались вопросы?</h2>
                            <div className="footer-contacts">
                                <div className="footer-contacts-row">
                                    <a className="footer-phone-link footer-phone-link-1" href="tel:84991304230">8 ( 499 )
                                        130 42
                                        30</a>
                                    <p className="footer-phone-text">Москва</p>
                                </div>
                                <div className="footer-contacts-row">
                                    <a className="footer-phone-link" href="tel:88047004230">8 ( 804 ) 700 42 30</a>
                                    <p className="footer-phone-text">Россия</p>
                                </div>
                            </div>
                        </div>
                        <div className="footer-contant-up-col footer-contant-up-col-2">
                            <p className="footer-button-text footer-button-text-1">Наши опытные менеджеры готовы помочь вам
                                оформить страховку под
                                ваш запрос.</p>
                            {/* <a className="button button-footer" data-da=".footer-contant-up-col-1,768,3"
                                href="javascript:PopUpShow()">Оформить с
                                менеджером</a> */}
                                <div onClick={() => {
                                        window.ym(90426649,'reachGoal','clck_zayavk')

                                        dispatch(setShowPopUpManager(true))
                                    }} class="button button-footer">
                                            Оформить с менеджером
                                        </div>
                        </div>
                    </div>
                    <div className="footer-contant-down">
                        <div className="footer-contant-down-col-1">
                            <a href="index.html"><img src={logo2} alt="logo" /></a>
                            <p className="footer-logo-text">Минимальная цена на обязательное <br />ипотечное страхование</p>
                            <div className="footer-blok-link">
                                <div className="footer-blok-link-left">
                                    <p className="footer-link-text footer-button-text">Услуги</p>
                                    <a className="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/">Страхование ипотеки</a>
                                    <a className="footer-link footer-logo-text" href="user.html">Личный кабинет</a>
                                    <a className="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/novostroiki/">Новостройки</a>
                                    <a className="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/banks/">Банки</a>
                                </div>
                                <div className="footer-blok-link-right">
                                    <p className="footer-link-text footer-button-text">Информация</p>
                                    <a className="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/o-kompanii/">О компании</a>
                                    <a className="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/news/">Новости</a>
                                    <a className="footer-link footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/kontakty/">Контакты</a>
                                </div>
                            </div>
                        </div>
                        <div className="footer-contant-down-col-2">
                            <a className="footer-link-right footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/policy/">Обработка персональных
                                данных</a>
                            <a className="footer-link-right footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/policy/">Политика
                                конфеденциальности</a>
                            <a className="footer-link-right footer-logo-text" href="https://dev.xn--80aafgiryleculn8b.xn--p1ai/policy/">Правовая информация</a>
                            <p className="footer-description">Сайт использует файлы «cookie» с целью персонализации сервисов
                                и повышения удобства
                                пользования веб-сайтом.Если вы не хотите использовать файлы «cookie», изменитенастройки
                                браузера.</p>
                            <img src={pay_logos} alt="banks" />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}